import { EditedRows } from "./edited-rows";
import { TableRow } from './table-row';

export class MyTableChanges {
  tableId: string;
  editedRows: EditedRows;

  constructor(tableId: string) {
    this.tableId = tableId;
    this.editedRows = new EditedRows();
  }
  editRow(rowData: TableRow) {
    const key = rowData.id;
    this.editedRows.addRow(key, rowData);
  }
  removeRow(rowData: TableRow) {
    const key = rowData.id;
    this.editedRows.removeRow(key);
  }
}